/* eslint-disable no-unused-vars */
/*
    Imports the Roast API URL from the config.
*/
import { OG_CONFIG } from '@/services/api/config.js';
import axios from 'axios';
import router from '../../../router';

const Qs = require('qs');
export default {
  getBaseUrl: function() {
    return OG_CONFIG.API_URL;
  },

  getHeaders: function(
    config = {
      upload: false,
    },
  ) {
    let token = localStorage.getItem('token');
    let headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    };

    if (token) {
      headers['Authorization'] = token;
    }

    if (config.upload) {
      headers['Content-Type'] = 'multipart/form-data';
    }
    return headers;
  },

  downloadBlob: function(url, config = {}) {
    if (!config.hasOwnProperty('params')) {
      config.params = {};
    }

    if (!config.params.hasOwnProperty('name')) {
      config.params.name = 'file';
    }

    if (!config.hasOwnProperty('responseType')) {
      config.responseType = 'blob';
    }

    if (!config.params.hasOwnProperty('extension')) {
      config.params.extension = 'zip';
    }

    config.paramsSerializer = function(params) {
      const res = Qs.stringify(params, {
        encode: false,
      });
      return res;
    };

    return axios.get(OG_CONFIG.API_URL + url, config).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', config.params.name + '.' + config.params.extension);
      document.body.appendChild(link);
      link.click();
    });
  },

  downloadFile: function(filePath, config = {}) {
    window.open(filePath, '_blank');
    // window.location.href = filePath;
  },

  get: function(url, config = {}, noToken = false) {
    return new Promise((resolve, reject) => {
      if (!config.hasOwnProperty('headers')) {
        config.headers = this.getHeaders();
      }

      if (!config.headers.hasOwnProperty('Authorization') && !noToken) {
        router.push('/login');
        // reject('There is no token');
      } else {
        config.paramsSerializer = function(params) {
          const res = Qs.stringify(params, {
            encode: false,
          });
          return res;
        };
        resolve(axios.get(OG_CONFIG.API_URL + url, config));
      }
    });
  },

  delete: function(url, config = {}) {
    return new Promise((resolve, reject) => {
      if (!config.hasOwnProperty('headers')) {
        config.headers = this.getHeaders();
      }

      if (!config.headers.hasOwnProperty('Authorization')) {
        router.push('/login');
        // reject('There is no token');
      } else {
        resolve(axios.delete(OG_CONFIG.API_URL + url, config));
      }
    });
  },

  post: function(url, data, config = {}) {
    return new Promise((resolve, reject) => {
      if (!config.hasOwnProperty('headers')) {
        config.headers = this.getHeaders();
      }
      if (!config.headers.hasOwnProperty('Authorization')) {
        router.push('/login');
        // reject('There is no token');
      } else {
        resolve(axios.post(OG_CONFIG.API_URL + url, data, config));
      }
    });
  },

  postUpload: function(url, data, config = {}) {
    return new Promise((resolve, reject) => {
      if (!config.hasOwnProperty('headers')) {
        config.headers = this.getHeaders({
          upload: true,
        });
      }
      if (!config.headers.hasOwnProperty('Authorization')) {
        router.push('/login');
        // reject('There is no token');
      } else {
        resolve(axios.post(OG_CONFIG.API_URL + url, data, config));
      }
    });
  },
};
